

















































































































































import Vue from "vue"
import ReceiverGroup, { IReceiverGroup } from "@/components/new-parcel-groups/ReceiverGroup.vue"
import ProductGroup, { IProductGroup } from "@/components/new-parcel-groups/ProductGroup.vue"
import AdditionalOptionsGroup, { TFood } from "@/components/new-parcel-groups/AdditionalOptionsGroup.vue"
import { IAdditionalOptionsGroup } from "@/components/new-parcel-groups/AdditionalOptionsGroup.vue"
import { ICodGroup } from "@/components/new-parcel-groups/CodGroup.vue"
import { DpdProduct } from "@/model/new-parcel-model/dpd-product/dpd-product"
import { DpdProductVariant } from "@/model/new-parcel-model/dpd-product/dpd-product-variant"
import { CreateParcelModel } from "@/model/new-parcel-model/create-parcel-model"
import { plainToClass } from "class-transformer"
import { ShipmentOptions } from "@/model/entity/shipment/shipment-options"
import { ShipmentCOD } from "@/model/entity/shipment/shipment-cod"
import { Shipment } from "@/model/entity/shipment/shipment"
import { Parcel } from "@/model/entity/parcel/parcel"
import ParcelShopGroup, { IParcelShopGroup } from "@/components/new-parcel-groups/ParcelShopGroup.vue"
import { ParcelCOD } from "@/model/entity/parcel/parcel-cod"
import { addressService, IAddressService } from "@/model/service/address/address-service"
import { IParcelService, parcelService } from "@/model/service/parcel/parcel-service"
import { saveAs } from "file-saver"
import { IExchangeGroup } from "@/components/new-parcel-groups/ExchangeGroup.vue"
import { AxiosResponse } from "axios"
import qz from "qz-tray"
import { ResolvedProductVariant, ParcelModelHelper } from "@/model/new-parcel-model/parcel-model-helper"
import { ParcelGoods } from "@/model/entity/shipment/parcel-goods"
import { IFoodGroup } from "@/components/new-parcel-groups/FoodGroup.vue"
import { Product } from "@/model/new-parcel-model/dpd-product/product"
import { CreateParcelModelExtensions } from "@/model/new-parcel-model/extension/create-parcel-model-extensions"
import * as _ from "lodash"
import LimitedQuantitySpecification, {
  ILimitedQuantitySpecification
} from "@/components/new-parcel-groups/LimitedQuantitySpecification.vue"
import { ParcelLimitedQuantity } from "@/model/entity/parcel/parcel-limited-quantity"

interface NewParcelData {
  dpdVariants: DpdProductVariant[] | null
  dpdProducts: DpdProduct[] | null
  dpdProduct: DpdProduct | null
  defaultProductVariant: DpdProductVariant | null
  createParcelModel: CreateParcelModel | null
  parcelNumber: number
  country: SimpleCountry | null
  addressService: IAddressService
  parcelService: IParcelService
  productValidated: boolean
  additionalOptionsValidated: boolean
  parcelShopValidated: boolean
  limitedQuantitySpecificationValidated: boolean
  receiverValidated: boolean
  hasProductVariant: boolean
  displayMsg: boolean
  countryRistricted: boolean
  comment: string
  sfs: boolean
  food: TFood
}

interface SimpleCountry {
  name: string
  code: string
  currency: string
  id: number
  restricted: boolean
}

interface ParcelCreationResponse {
  parcelList: Parcel[]
  code: number
  message: string
}

export default Vue.extend({
  components: {
    AdditionalOptionsGroup,
    ReceiverGroup,
    ProductGroup,
    ParcelShopGroup,
    LimitedQuantitySpecification
  },
  data(): NewParcelData {
    return {
      dpdVariants: [],
      dpdProducts: [],
      dpdProduct: null,
      defaultProductVariant: null,
      createParcelModel: null,
      parcelNumber: 1,
      country: null,
      comment: null,
      addressService: addressService,
      parcelService: parcelService,
      productValidated: true,
      parcelShopValidated: true,
      limitedQuantitySpecificationValidated: true,
      additionalOptionsValidated: true,
      receiverValidated: false,
      hasProductVariant: true,
      displayMsg: false,
      countryRistricted: false,
      sfs: false,
      food: null
    }
  },
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    parcel: {
      type: Parcel
    },
    resolvedExternalProductVariant: {
      type: ResolvedProductVariant
    }
  },
  methods: {
    handleParcelResponse(response: AxiosResponse<ParcelCreationResponse>, addressResponse?: AxiosResponse) {
      const vm = this
      vm.endLoad()
      if (response.data.code === 0) {
        const postalCode = response.data.parcelList[0].shipment.shipmentReceiver.postalCode
        const undeliverableZipcodes = [21485, 23210, 23273, 51550]
        vm.parcelService
          .checkZipCodeCountry(response.data.parcelList[0])
          .then(response => {
            if (!response.data) {
              if (_.includes(undeliverableZipcodes, Number(postalCode))) {
                vm.$confirm(vm.$t(`undeliverable_zipcode.${postalCode}.warning`).toString(), {
                  confirmButtonText: "OK",
                  type: "warning",
                  center: true,
                  showCancelButton: false
                })
              } else {
                vm.$confirm(vm.$t("undeliverable_zipcode.warning").toString(), {
                  confirmButtonText: "OK",
                  type: "warning",
                  center: true,
                  showCancelButton: false
                })
              }
            } else {
              this.displayMsg = true
            }
          })
          .then(() => {
            vm.initiateCreateParcelModel()
            vm.clearAllGroups()
            if (this.displayMsg) {
              vm.$message({
                message: vm.$t("new_parcel.save_success").toString(),
                type: "success"
              })
              this.displayMsg = false
            }
            this.comment = null
          })
          .catch(error => {
            vm.$error(error.response.data.message)
            vm.endLoad()
          })
      } else {
        if (addressResponse !== undefined) {
          this.addressService.delete(addressResponse.data.id)
        }
        vm.$error(response.data.message)
      }
    },
    clearAll() {
      const vm = this
      const domesticCountryCode = vm.$store.state.authenticatedEmployee.office.country.isoCodeAlpha2
      const codCountries = vm.$store.getters.codCountries
      const roadExportCountries = vm.$store.getters.roadExportCountries
      vm.createParcelModel = new CreateParcelModel(
        vm.dpdVariants,
        vm.dpdProducts[0],
        domesticCountryCode,
        domesticCountryCode,
        codCountries,
        roadExportCountries
      )
      vm.parcelNumber = 1
      const userCountry = this.$store.state.authenticatedEmployee.office.country

      vm.country = {
        name: userCountry.name,
        code: userCountry.isoCodeAlpha2,
        currency: userCountry.currency,
        restricted: userCountry.restricted || false,
        id: userCountry.id
      }

      const productGroup = vm.$refs.productGroup as IProductGroup
      const receiverGroup = vm.$refs.receiverGroup as IReceiverGroup
      const additionalOptionsGroup = vm.$refs.additionalOptionsGroup as IAdditionalOptionsGroup
      const parcelShopGroup = vm.$refs.parcelShopGroup as IParcelShopGroup
      const limitedQuantitySpecification = vm.$refs.limitedQuantitySpecification as ILimitedQuantitySpecification
      productGroup.clearAll()
      receiverGroup.clearAll()
      additionalOptionsGroup.clearAll()
      parcelShopGroup.clearAll()
      limitedQuantitySpecification.clearAll()
    },
    async save(addressResponse: AxiosResponse) {
      const vm = this
      if (
        (vm.createParcelModel.country === "DE" && vm.createParcelModel.weight === 0) ||
        (vm.createParcelModel.weight === 0 && this.showLimitedQuantitySpecification)
      ) {
        this.$message({
          message: vm.$t("new.parcel.error.weight_not_set").toString(),
          type: "error",
          duration: 5000
        })
        return
      }
      vm.startLoad()
      await vm.checkCountry()
      vm.$http
        .post("/parcel/new", vm.getNewParcelRequest())
        .then(response => vm.handleParcelResponse(response, addressResponse))
        .catch(() => {
          vm.endLoad()
        })
    },
    getNewParcelRequest(): any {
      const vm = this
      const createParcelModel = vm.createParcelModel
      const productGroup = vm.$refs.productGroup as IProductGroup
      const receiverGroup = vm.$refs.receiverGroup as IReceiverGroup
      const additionalOptionsGroup = vm.$refs.additionalOptionsGroup as IAdditionalOptionsGroup
      const codGroup = additionalOptionsGroup.$refs.codGroup as ICodGroup
      const exchangeGroup = additionalOptionsGroup.$refs.exchangeGroup as IExchangeGroup
      const parcelShopGroup = vm.$refs.parcelShopGroup as IParcelShopGroup
      const limitedQuantitySpecification = vm.$refs.limitedQuantitySpecification as ILimitedQuantitySpecification
      const shipmentParcelShop = parcelShopGroup.getParcelShop()
      let parcelLimitedQuantity = null
      if (limitedQuantitySpecification) {
        parcelLimitedQuantity = limitedQuantitySpecification.form
      }

      const shipmentSender = vm.$store.getters.shipmentSender(productGroup.form.note)

      const shipmentRecipient = receiverGroup.getRecipient()

      const shipmentDeskDelivery = additionalOptionsGroup.getDeskDelivery()

      const shipmentIdCheck = additionalOptionsGroup.getIdCheck()

      const parcelGoods = additionalOptionsGroup.getFood()

      const shipmentOptions = new ShipmentOptions(
        createParcelModel!.createParcelModelOptions.returnOfDocument.value,
        createParcelModel!.createParcelModelOptions.deskDelivery.value,
        createParcelModel!.createParcelModelOptions.idCheck.value,
        receiverGroup.isPredictActive,
        createParcelModel!.createParcelModelExtensions.document.value
      )
      if (codGroup.codType !== "102" && codGroup.codType !== "103") {
        codGroup.amount = codGroup.amountArray.reduce((partialSum, a) => Number(partialSum) + Number(a), 0)
      }
      const shipmentCod = new ShipmentCOD(
        codGroup.form.reference,
        codGroup.amount,
        vm.country!.currency,
        Number(codGroup.codType)
      )

      const shipment = new Shipment(
        vm.parcelNumber,
        productGroup.form.reference,
        "UI",
        createParcelModel!.createParcelModelExtensions.parcelShop.value ? shipmentParcelShop : undefined,
        shipmentSender,
        shipmentRecipient,
        createParcelModel!.createParcelModelOptions.deskDelivery.value ? shipmentDeskDelivery : undefined,
        createParcelModel!.createParcelModelOptions.idCheck.value ? shipmentIdCheck : undefined,
        shipmentOptions,
        createParcelModel!.createParcelModelExtensions.cashOnDelivery.value ? shipmentCod : undefined
      )
      const overrideServiceCode: string =
        (this.sfs && createParcelModel.dpdProduct.type === "DPD_HOME" && "404") ||
        (this.sfs && createParcelModel.dpdProduct.type === "DPD_BUSINESS" && "400") ||
        (this.food &&
          ["DPD_FOOD", "DPD_FRESH", "DPD_FROZEN"].includes(createParcelModel.dpdProduct.type) &&
          this.getFoodServiceCode()) ||
        ""
      shipment.shipmentSender.comment = this.comment
      const parcelList: Parcel[] = []
      if (productGroup.sameWeight && productGroup.sameDimension) {
        this.createParcelModel!.weight = productGroup.packageWeight * 1000
        this.createParcelModel!.dimension = productGroup.packageDimension
        for (let index = 0; index < vm.parcelNumber; index++) {
          parcelList.push(
            this.createParcel(
              createParcelModel!,
              index,
              codGroup,
              vm.parcelNumber,
              productGroup.form.reference,
              productGroup.form.reference2,
              overrideServiceCode,
              parcelGoods,
              parcelLimitedQuantity
            )
          )
        }
      } else if (productGroup.sameWeight && !productGroup.sameDimension) {
        this.createParcelModel!.weight = productGroup.packageWeight * 1000
        if (productGroup.packageDimensionArray.length === 0) {
          productGroup.packageDimensionArray = [""]
        }
        productGroup.packageDimensionArray.forEach((packageDimension, index) => {
          this.createParcelModel!.dimension = packageDimension
          parcelList.push(
            this.createParcel(
              createParcelModel!,
              index,
              codGroup,
              vm.parcelNumber,
              productGroup.form.reference,
              productGroup.form.reference2,
              overrideServiceCode,
              parcelGoods,
              parcelLimitedQuantity
            )
          )
        })
      } else if (!productGroup.sameWeight && productGroup.sameDimension) {
        this.createParcelModel!.dimension = productGroup.packageDimension
        productGroup.packageWeightArray.forEach((packageWeight, index) => {
          this.createParcelModel!.weight = packageWeight
          parcelList.push(
            this.createParcel(
              createParcelModel!,
              index,
              codGroup,
              vm.parcelNumber,
              productGroup.form.reference,
              productGroup.form.reference2,
              overrideServiceCode,
              parcelGoods,
              parcelLimitedQuantity
            )
          )
        })
      } else {
        productGroup.packageWeightArray.forEach((packageWeight, index) => {
          this.createParcelModel!.weight = packageWeight * 1000
          for (let i = index; i <= index; i++) {
            this.createParcelModel.dimension = productGroup.packageDimensionArray[i]
            parcelList.push(
              this.createParcel(
                createParcelModel!,
                index,
                codGroup,
                vm.parcelNumber,
                productGroup.form.reference,
                productGroup.form.reference2,
                overrideServiceCode,
                parcelGoods,
                parcelLimitedQuantity
              )
            )
          }
        })
      }

      return {
        shipment: shipment,
        parcelList: parcelList,
        numOfExchangeParcels: exchangeGroup.form.exchangeNumber
      }
    },
    createParcel(
      createParcelModel: CreateParcelModel,
      index: number,
      codGroup: ICodGroup,
      parcelNumber: number,
      reference: string,
      reference2: string,
      overrideServiceCode: string,
      parcelGoods: ParcelGoods,
      parcelLimitedQuantity: ParcelLimitedQuantity
    ) {
      let parcelCod: ParcelCOD | undefined
      if (createParcelModel.createParcelModelExtensions.cashOnDelivery.value) {
        if (codGroup.codType === "102") {
          if (index === 0) {
            parcelCod = new ParcelCOD(codGroup.amount)
          } else {
            parcelCod = new ParcelCOD(0)
          }
        } else if (codGroup.codType === "103") {
          const parcelValue = Number.parseFloat((codGroup.amount / parcelNumber).toFixed(2))
          if (index + 1 < parcelNumber) {
            parcelCod = new ParcelCOD(parcelValue)
          } else {
            const lastParcelDiff = codGroup.amount - (parcelNumber - 1) * parcelValue
            parcelCod = new ParcelCOD(lastParcelDiff)
          }
        } else {
          parcelCod = new ParcelCOD(codGroup.amountArray[index])
        }
      }

      let serviceBackCode = null
      if (createParcelModel.dpdProductVariant && createParcelModel.dpdProductVariant.serviceBackCode) {
        serviceBackCode = createParcelModel.dpdProductVariant.serviceBackCode
      }

      return new Parcel(
        createParcelModel.weight,
        overrideServiceCode !== "" ? overrideServiceCode : createParcelModel.dpdProductVariant.serviceCode.toString(),
        serviceBackCode,
        index + 1,
        undefined,
        parcelCod,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        reference,
        reference2,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        createParcelModel.dimension,
        ["DPD_FOOD", "DPD_FRESH", "DPD_FROZEN"].includes(createParcelModel.dpdProduct.type) ? parcelGoods : undefined,
        createParcelModel.dpdProductVariant.asCode,
        parcelLimitedQuantity
      )
    },
    async checkCountry() {
      const vm = this
      if (this.country.code === "GB") {
        await vm
          .$confirm(vm.$t("new.parcel.warning_uk_customs_invoice").toString(), {
            confirmButtonText: "OK",
            type: "warning",
            center: true,
            showCancelButton: false
          })
          .catch(error => {
            return
          })
      }
      if (this.country.code === "BA" || this.country.code === "RS") {
        await vm
          .$confirm(vm.$t("new.parcel.warning_eu_customs_invoice").toString(), {
            confirmButtonText: "OK",
            type: "warning",
            center: true,
            showCancelButton: false
          })
          .catch(error => {
            return
          })
      }
    },
    saveParcelAndAddress() {
      this.saveAddress(this.save)
    },
    saveAddress(thenFunction: any) {
      const vm = this as any
      const receiverGroup = this.$refs.receiverGroup as IReceiverGroup
      const address = receiverGroup.getAddress()
      address.comment = vm.comment

      this.addressService
        .create(address)
        .then((response: AxiosResponse) => {
          thenFunction(response).then(() => {
            vm.comment = null
          })
        })
        .catch((e: any) => {
          this.$error(e.response.data.message)
        })
    },
    async print(addressResponse: AxiosResponse) {
      const vm = this
      if (
        (vm.createParcelModel.country === "DE" && vm.createParcelModel.weight === 0) ||
        (vm.createParcelModel.weight === 0 && this.showLimitedQuantitySpecification)
      ) {
        this.$message({
          message: vm.$t("new.parcel.error.weight_not_set").toString(),
          type: "error",
          duration: 5000
        })
        return
      }
      vm.startLoad()
      await vm.checkCountry()
      vm.$http
        .post("/parcel/new", vm.getNewParcelRequest())
        .then(response => {
          if (response.data.code === 0) {
            vm.parcelService
              .print(response.data.parcelList.map((parcel: Parcel) => parcel.id))
              .then(innerResponse => {
                vm.handleFileResponse(innerResponse)
                vm.handleParcelResponse(response, addressResponse)
              })
              .catch(() => {
                vm.endLoad()
              })
          } else {
            vm.handleParcelResponse(response, addressResponse)
          }
        })
        .catch(() => {
          vm.endLoad()
        })

      this.comment = null
    },
    initiateFromExistingParcel() {
      const vm = this
      const shipment = vm.parcel.shipment!
      vm.parcel.weight = vm.parcel.weightKg
      const codCountries = vm.$store.getters.codCountries
      const roadExportCountries = vm.$store.getters.roadExportCountries
      vm.createParcelModel = null
      vm.createParcelModel = new CreateParcelModel(
        [vm.resolvedExternalProductVariant.dpdProductVariant],
        {
          title: vm.resolvedExternalProductVariant.dpdProductVariant.productType,
          type: vm.resolvedExternalProductVariant.dpdProductVariant.productType
        },
        shipment.shipmentReceiver!.country.isoCodeAlpha2,
        shipment.shipmentSender!.country.isoCodeAlpha2,
        codCountries,
        roadExportCountries
      )
      vm.country = {
        name: shipment.shipmentReceiver!.country.name,
        code: shipment.shipmentReceiver!.country.isoCodeAlpha2,
        id: shipment.shipmentReceiver!.country.id,
        currency: shipment.shipmentReceiver!.country.currency,
        restricted: shipment.shipmentReceiver!.country.restricted || false
      }

      vm.$nextTick(() => {
        const productGroup = vm.$refs.productGroup as IProductGroup
        const receiverGroup = vm.$refs.receiverGroup as IReceiverGroup
        const additionalOptionsGroup = vm.$refs.additionalOptionsGroup as IAdditionalOptionsGroup
        const codGroup = additionalOptionsGroup.$refs.codGroup as ICodGroup
        const parcelShopGroup = vm.$refs.parcelShopGroup as IParcelShopGroup
        const limitedQuantitySpecification = vm.$refs.limitedQuantitySpecification as ILimitedQuantitySpecification
        if (limitedQuantitySpecification) {
          limitedQuantitySpecification.form = vm.parcel.parcelLimitedQuantity
        }
        receiverGroup.setRecipient(shipment.shipmentReceiver!)
        productGroup.form.note = shipment.shipmentSender!.comment
        productGroup.form.reference = vm.parcel.parcelReference!
        productGroup.form.reference2 = vm.parcel.parcelReference2!
        productGroup.form.dimension = vm.parcel.dimension!
        const createParcelModelOptions = vm.createParcelModel!.createParcelModelOptions
        createParcelModelOptions.returnOfDocument.value = shipment.shipmentOptions!.returnOfDocument
        createParcelModelOptions.deskDelivery.value = shipment.shipmentOptions!.deskDelivery
        createParcelModelOptions.idCheck.value = shipment.shipmentOptions!.idCheck
        createParcelModelOptions.predict.value = shipment.shipmentOptions!.predict

        vm.createParcelModel!.createParcelModelExtensions.document.value = shipment.shipmentOptions!.document

        const hasCod = exists(vm.parcel.parcelCOD)
        vm.createParcelModel!.createParcelModelExtensions.cashOnDelivery.value = hasCod
        if (hasCod) {
          codGroup.form.reference = shipment.shipmentCOD!.reference
          codGroup.amount = vm.parcel!.parcelCOD!.amount
        }

        if (shipment.shipmentOptions!.idCheck) {
          additionalOptionsGroup.setIdCheck(shipment.shipmentIdCheck!)
        }

        if (shipment.shipmentOptions!.deskDelivery) {
          additionalOptionsGroup.setDeskDelivery(shipment.shipmentDeskDelivery!)
        }
        vm.createParcelModel!.createParcelModelExtensions.sameDay.value =
          vm.resolvedExternalProductVariant.dpdProductVariant.sameDay

        vm.createParcelModel!.createParcelModelExtensions.saturdayDelivery.value =
          vm.resolvedExternalProductVariant.dpdProductVariant.saturdayDelivery

        vm.createParcelModel!.createParcelModelExtensions.exchange.value =
          (exists(vm.parcel.serviceBackCode) && vm.parcel.serviceBackCode !== "332") || exists(shipment.parentShipment)

        const hasParcelShop = exists(shipment.shipmentParcelShop)
        vm.createParcelModel!.createParcelModelExtensions.parcelShop.value = hasParcelShop
        if (hasParcelShop) {
          parcelShopGroup.setParcelShopFromShipment(shipment.shipmentParcelShop!)
        }

        const hasParcelGoods = exists(vm.parcel.parcelGoods)
        if (hasParcelGoods) {
          additionalOptionsGroup.setFood(vm.parcel.parcelGoods)
        }

        vm.createParcelModel!.createParcelModelExtensions.returnParcel.value =
          vm.resolvedExternalProductVariant.dpdProductVariant.returnParcel
      })
    },
    initiateCreateParcelModel() {
      const vm = this
      this.scrollToTop()

      const domesticCountryCode = vm.$store.getters.domesticCountryIso
      const codCountries = vm.$store.getters.codCountries
      const roadExportCountries = vm.$store.getters.roadExportCountries
      const defaultServiceCode =
        vm.$store.state.authenticatedEmployee.office.company.defaultProduct ||
        vm.$store.state.authenticatedEmployee.office.company.productVariants.split(",")[0]
      const parcelModelHelper = new ParcelModelHelper(vm.dpdVariants)
      const resolvedProductVariant = vm.defaultProductVariant
      vm.createParcelModel = new CreateParcelModel(
        parcelModelHelper.dpdProductVariant,
        vm.dpdProduct,
        domesticCountryCode,
        domesticCountryCode,
        codCountries,
        roadExportCountries
      )
      const extensions = vm.createParcelModel.createParcelModelExtensions
      extensions.cashOnDelivery.value = resolvedProductVariant.cashOnDelivery
      extensions.document.value = resolvedProductVariant.document
      extensions.exchange.value = resolvedProductVariant.exchange
      extensions.parcelShop.value = resolvedProductVariant.parcelShop
      extensions.sameDay.value = resolvedProductVariant.sameDay
      extensions.returnParcel.value = resolvedProductVariant.returnParcel
      extensions.saturdayDelivery.value = resolvedProductVariant.saturdayDelivery
      extensions.food.value = resolvedProductVariant.food
      vm.parcelNumber = 1
      const userCountry = this.$store.state.authenticatedEmployee.office.country

      vm.country = {
        name: userCountry.name,
        code: userCountry.isoCodeAlpha2,
        currency: userCountry.currency,
        id: userCountry.id,
        restricted: userCountry.restricted || false
      }
      this.scrollToTop()
    },
    clearAllGroups() {
      const vm = this
      const productGroup = vm.$refs.productGroup as IProductGroup
      const receiverGroup = vm.$refs.receiverGroup as IReceiverGroup
      const additionalOptionsGroup = vm.$refs.additionalOptionsGroup as IAdditionalOptionsGroup
      const parcelShopGroup = vm.$refs.parcelShopGroup as IParcelShopGroup
      const limitedQuantitySpecification = vm.$refs.limitedQuantitySpecification as ILimitedQuantitySpecification
      productGroup.clearAll()
      receiverGroup.clearAll()
      additionalOptionsGroup.clearAll()
      parcelShopGroup.clearAll()
      limitedQuantitySpecification.clearAll()
    },
    async prepareNewParcel() {
      const vm = this

      await this.$http.get("/product/employee_products").then(res => {
        vm.dpdProducts = res.data
      })
      const defaultServiceCode = vm.$store.state.authenticatedEmployee.office.company.defaultProduct
      await this.$http.get(`/product/product_variant/${defaultServiceCode}`).then(res => {
        vm.dpdProduct = vm.dpdProducts.find(obj => {
          return obj.type === res.data.productType
        })
      })
      const countryId = vm.$store.state.authenticatedEmployee.office.country.id
      await this.$http.get(`/product/employee_product_variant/${vm.dpdProduct.type}/${countryId}`).then(res => {
        vm.dpdVariants = plainToClass(DpdProductVariant, res.data)
        vm.defaultProductVariant = res.data.find(obj => {
          return obj.serviceCode === Number(defaultServiceCode)
        })
        vm.initiateCreateParcelModel()
      })
    },
    printAndSaveAddress() {
      this.saveAddress(this.print)
    },
    handleFileResponse(response: any) {
      const vm = this
      const employee = this.$store.state.authenticatedEmployee
      if (
        (employee.office.reportPageFormat === "ZPL_203" || employee.office.reportPageFormat === "ZPL_300") &&
        employee.office.printingMethod === "MIDDLEWARE" &&
        notEmpty(employee.office.printer)
      ) {
        const data = new TextDecoder().decode(response.data)
        const config = qz.configs.create(employee.office.printer)
        const call = () =>
          qz
            .print(config, [data])
            .then()
            .catch((e: any) => vm.$error(vm.$t("qz.error")))
        this.executeQz(call)
      } else {
        const contentType = response.headers["content-type"]
        const blob = new Blob([response.data], { type: contentType })
        const filename = response.headers["content-disposition"].match(/attachment; filename=(.*)/)[1]
        saveAs(blob, filename)
      }
    },
    executeQz(call: () => void) {
      const vm = this
      if (qz.websocket.isActive()) {
        call()
      } else {
        qz.websocket
          .connect()
          .then(call)
          .catch((e: any) => vm.$error(vm.$t("qz.error")))
      }
    },
    scrollToTop() {
      (this.$refs.newParcelPanelContainer as Vue).$el.scrollTop = 0
    },
    sfsChanged(value) {
      this.sfs = value
    },
    foodProductChanged(value: TFood) {
      this.food = value
    },
    getFoodServiceCode(): string {
      const currentWsTextCode: string = this.createParcelModel.dpdProductVariant.wsTextCode
      const splitCurrentWsTextCode: string[] = currentWsTextCode.split("-")
      splitCurrentWsTextCode[this.getFoodServiceIndex(splitCurrentWsTextCode)] = this.food.toString().toUpperCase()
      const wouldBeWsTextCode: string = splitCurrentWsTextCode.join("-")
      const filter: DpdProductVariant[] = this.createParcelModel.dpdProductVariants.filter(
        (product: DpdProductVariant) => product.wsTextCode === wouldBeWsTextCode
      )
      return filter[0].serviceCode.toString()
    },
    getFoodServiceIndex(inputArray: string[]): number {
      const index = inputArray.findIndex(el => {
        return el === "FOOD" || el === "FRESH" || el === "FROZEN"
      })
      return ~index ? index : 1
    }
  },
  computed: {
    validationsPassed(): boolean {
      return (
        this.hasProductVariant &&
        this.productValidated &&
        this.additionalOptionsValidated &&
        this.receiverValidated &&
        this.parcelShopValidated &&
        this.limitedQuantitySpecificationValidated &&
        !this.countryRistricted
      )
    },
    sfsChecked(): boolean {
      if (!this.readonly) {
        return false
      }
      try {
        this.sfs =
          this.resolvedExternalProductVariant.dpdProductVariant.serviceCode === 400 ||
          this.resolvedExternalProductVariant.dpdProductVariant.serviceCode === 404
        return this.sfs
      } catch (e) {
        return false
      }
    },
    showLimitedQuantitySpecification(): boolean {
      return (
        this.createParcelModel.dpdProduct.type === "DPD_LIMITED_QUANTITY_BUSINESS" ||
        this.createParcelModel.dpdProduct.type === "DPD_LIMITED_QUANTITY_HOME"
      )
    }
  },
  watch: {
    parcel: {
      handler() {
        this.initiateFromExistingParcel()
      }
    },
    "createParcelModel.createParcelModelExtensions.parcelShop.value": {
      deep: true,
      handler(newVal: boolean) {
        if (newVal) {
          const parcelShopGroup = this.$refs.parcelShopGroup as IParcelShopGroup
          if (exists(parcelShopGroup)) {
            parcelShopGroup.focusAutocomplete()
            parcelShopGroup.emitValidation()
          }
        } else {
          this.parcelShopValidated = true
        }
      }
    },
    "createParcelModel.dpdProduct.type": {
      deep: true,
      handler(newVal: string) {
        this.createParcelModel.createParcelModelExtensions = new CreateParcelModelExtensions(this.createParcelModel)
        if (this.createParcelModel.dpdProduct.type === "DPD_HOME") {
          this.createParcelModel.createParcelModelExtensions.b2c.value = true
        } else {
          this.createParcelModel.createParcelModelExtensions.b2c.value = false
        }
        if (
          this.createParcelModel.dpdProduct.type === "DPD_SHOP" ||
          this.createParcelModel.dpdProduct.type === "DPD_SHOP_2_SHOP"
        ) {
          this.createParcelModel.createParcelModelExtensions.parcelShop.value = true
        } else {
          this.createParcelModel.createParcelModelExtensions.parcelShop.value = false
        }
      }
    },
    country: {
      handler(country: SimpleCountry) {
        this.createParcelModel.country = country.code
        const vm = this
        if (country.restricted) {
          vm.$confirm(vm.$t("new.parcel.error.country_restricted").toString(), {
            confirmButtonText: "OK",
            type: "warning",
            center: true,
            showCancelButton: false
          })
          this.countryRistricted = true
        } else {
          this.countryRistricted = false
        }

        if (country.id && vm.createParcelModel.dpdProduct.type !== "DPD_AIR" && !vm.readonly) {
          this.$http
            .get(`/product/employee_product_variant/${vm.createParcelModel.dpdProduct.type}/${this.country.id}`)
            .then(res => {
              vm.dpdVariants = plainToClass(DpdProductVariant, res.data)
              vm.createParcelModel.dpdProductVariants = vm.dpdVariants
              vm.createParcelModel!.country = country.code
              const domesticCountryCode = country.code
              const codCountries = vm.$store.getters.codCountries
              const roadExportCountries = vm.$store.getters.roadExportCountries
              const parcelModelHelper = new ParcelModelHelper(vm.dpdVariants)
              const resolvedProductVariant = vm.dpdVariants[0]
              const dpdProduct = this.createParcelModel.dpdProduct
              const weight = this.createParcelModel.weight
              vm.createParcelModel = new CreateParcelModel(
                parcelModelHelper.dpdProductVariant,
                dpdProduct,
                country.code,
                domesticCountryCode,
                codCountries,
                roadExportCountries,
                weight
              )
              const extensions = vm.createParcelModel.createParcelModelExtensions
              extensions.cashOnDelivery.value = resolvedProductVariant.cashOnDelivery
              extensions.document.value = resolvedProductVariant.document
              extensions.exchange.value = resolvedProductVariant.exchange
              extensions.parcelShop.value = resolvedProductVariant.parcelShop
              extensions.sameDay.value = resolvedProductVariant.sameDay
              extensions.returnParcel.value = resolvedProductVariant.returnParcel
              extensions.saturdayDelivery.value = resolvedProductVariant.saturdayDelivery
              extensions.food.value = resolvedProductVariant.food
              vm.parcelNumber = 1
            })
        }
      }
    },
    comment: {
      handler(comment: any) {
        const vm = this
        const productGroup = vm.$refs.productGroup as IProductGroup
        productGroup.form.note = comment
      }
    }
  },
  created() {
    const vm = this

    if (vm.readonly) {
      this.initiateFromExistingParcel()
    } else {
      this.prepareNewParcel()
    }
  }
})
